<template>
  <section class="oa-section">
    <div class="oa-section-header">
      <h2><i class="fa fa-globe"></i> Preview Booking Page</h2>
      <div class="oa-header-actions">
        <button class="oa-btn oa-btn-secondary" @click="refreshPreview">
          <i class="fa fa-refresh"></i> Refresh
        </button>
        <a v-if="bookingUrl" class="oa-btn oa-btn-secondary" :href="bookingUrl" target="_blank">
          <i class="fa fa-external-link"></i> Open in New Tab
        </a>
      </div>
    </div>

    <!-- Location Selector (only if multiple paid locations) -->
    <LocationSelector
      v-model="selectedSiteId"
      :locations="paidLocations"
      :locationStatus="{}"
      label="Previewing:"
      :showCopyButton="false"
      :showCount="false"
    />

    <div class="oa-info-box oa-info-box-blue" style="margin-bottom: 16px;">
      <div class="oa-info-box-title">
        <i class="fa fa-info-circle"></i>
        <span>Live Preview</span>
      </div>
      <p>This is exactly how patients will see your online booking page. Walk through the full flow to verify your appointment types, providers, and calendar availability. Booking is disabled in preview mode.</p>
    </div>

    <div class="preview-calendar">
      <div class="calendar-frame-wrapper">
        <iframe
          v-if="bookingUrl"
          ref="previewIframe"
          :src="iframeSrc"
          class="calendar-iframe"
          frameborder="0"
          allow="clipboard-write"
        ></iframe>
        <div v-else class="oa-empty-state">
          <i class="fa fa-exclamation-circle"></i>
          <p>Unable to load preview — site ID not available.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
import LocationSelector from './LocationSelector.vue';

export default {
  name: 'PreviewCalendar',
  components: { LocationSelector },
  props: {
    siteID: { type: String, default: '' },
    paidLocations: { type: Array, default: () => [] },
    currentSiteId: { type: String, default: '' }
  },

  data() {
    return {
      selectedSiteId: '',
      refreshKey: 0
    };
  },

  computed: {
    hasMultipleLocations() {
      return this.paidLocations && this.paidLocations.length > 1;
    },

    bookingUrl() {
      const targetSiteId = this.hasMultipleLocations ? this.selectedSiteId : this.siteID;
      if (!targetSiteId) return '';
      return `/online-scheduling/book-appointment.html?siteID=${targetSiteId}&preview=true`;
    },

    // Append refreshKey to force iframe reload
    iframeSrc() {
      if (!this.bookingUrl) return '';
      return `${this.bookingUrl}&_r=${this.refreshKey}`;
    },

    selectedLocationName() {
      const loc = this.paidLocations.find(l => l.siteId === this.selectedSiteId);
      return loc ? loc.name : '';
    }
  },

  methods: {
    refreshPreview() {
      this.refreshKey = Date.now();
    }
  },

  watch: {
    currentSiteId: {
      handler(newVal) {
        if (newVal && newVal !== this.selectedSiteId) {
          this.selectedSiteId = newVal;
        }
      },
      immediate: true
    },

    selectedSiteId(newVal, oldVal) {
      if (newVal && newVal !== oldVal && oldVal !== '') {
        this.$emit('location-changed', newVal);
      }
    },

    siteID: {
      handler(newVal) {
        if (!this.hasMultipleLocations && newVal && !this.selectedSiteId) {
          this.selectedSiteId = newVal;
        }
      },
      immediate: true
    }
  }
};
</script>
